module.exports = __webpack_public_path__ + "static/12-4202d37b7978bea9e111f3fb458102ea.jpg";